import React from "react";
import { Toaster } from "sonner";

export const ToastContainer = () => {
    return <Toaster />;
};
